<template>
  <v-card class="mx-auto">
    <v-card-title>Outcome of Treatment</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col>
            <v-radio-group
                v-model="formData.outcome_treatment.outcome"
                :rules="outcomeRules"
                hide-details
            >
              <v-radio
                  v-for="option in outcomeOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
              />
            </v-radio-group>
            <v-col cols="12" sm="6" md="4">
            <v-text-field
                v-model="formData.outcome_treatment.reason"
                label="Specify Reason"
            ></v-text-field>
            </v-col>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
          :disabled="currentTab === 0"
          @click="backTab"
          color="info"
          class="mr-4">
        BACK
      </v-btn>
      <v-btn
          :disabled="!formData.outcome_treatment.outcome"
          @click="validate"
          color="success"
          class="mr-4">
        NEXT
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    currentTab: Number,
    formData: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      modal: false,
      valid: false,
      outcomeOptions: [
        { label: 'Improved', value: 'IMPROVED' },
        { label: 'Recovered', value: 'RECOVERED' },
        { label: 'Hama/Dama', value: 'HAMADAMA' },
        { label: 'Expired', value: 'EXPIRED' },
        { label: 'Absconded', value: 'ABSCONDED' },
        { label: 'Transferred', value: 'TRANSFERRED' }
      ],
      outcomeRules: [
        v => !!v || 'Please select a treatment outcome'
      ]
    }
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.$bus.emit('nextTab', this.currentTab + 1);
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    backTab() {
      this.$bus.emit('nextTab', this.currentTab - 1);
    },
  },
}
</script>

<style scoped>

</style>